<template>
  <vs-popup class="popup-reformation-plan" :title="title" :active.sync="showPopup">
    <div>
      <div class="mb-4" vs-type="flex">
        <h5><i class="dot"></i> 개선방안</h5>
      </div>
      <div class="writeGridContainer">
        <div class="col-span-6">
          <label>개선 담당자</label>
          <ml-input type="text" :readonly="readonly" v-model="form.개선방안.개선담당자" />
        </div>
        <div class="col-span-6">
          <label>개선 완료 예정일</label>
          <date-selector v-model="form.개선방안.개선완료예정일" :readonly="readonly" />
        </div>
        <div class="writeGridLineItem">
          <label>개선 방법</label>
          <ml-textarea type="text" v-model="form.개선방안.개선방법" :readonly="readonly" />
        </div>
      </div>
      <div class="flex justify-end gap-4">
        <vs-button type="border" color="secondary" @click="close">닫기</vs-button>
        <vs-button v-if="!readonly" color="secondary" @click="save">저장</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {DateSelector},
  props: {
    title: {
      type: String,
      default: "개선방안",
    },
    value: Boolean,
    dataCode: String,
    postId: Number,
    data: Object,
    readonly: Boolean,
  },
  computed: {
    showPopup: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value) {

          if (this.data) {
            const keys = Object.keys(this.data);
            for (const key of keys) {
              if (this.data[key]) {
                this.form[key] = this.data[key];
              }
            }
          } else {
            // 초기화
            this.form = {
              dataCode: this.dataCode,
              개선방안: {
                개선담당자: '',
                개선완료예정일: '',
                개선방법: '',
              }
            }
          }

        }
      }
    }
  },
  data () {
    return {
      form: {
        dataCode: this.dataCode,
        개선방안: {
          개선담당자: '',
          개선완료예정일: '',
          개선방법: '',
        }
      }
    }
  },
  methods: {
    close() {
      this.showPopup = false;
    },
    save() {
      this.form.dataCode = this.dataCode;
      this.$emit("save", this.postId, this.form)
      this.showPopup = false;
    }
  }
}
</script>

<style scoped lang="scss">
.popup-reformation-plan::v-deep {
  .vs-popup {
    width: 840px;
  }
}
</style>
